// extracted by mini-css-extract-plugin
export default {"nav-item":"index-module--nav-item--wBsgV","nav-item--active":"index-module--nav-item--active--XTjbF"};